// src/Layout.js
import React from 'react';
import { Helmet } from 'react-helmet';

export const metadata = {
    title: "HeliosLabs.AI | Pioneering AI-Powered Workflow Automation",
    description: "Transform your business operations with HeliosLabs.AI. We harness cutting-edge AI to streamline and optimize internal processes, unlocking new levels of efficiency and intelligence in supply chain, logistics, and transportation.",
    keywords: "AI solutions, workflow automation, business operations, supply chain optimization, logistics AI, transportation automation",
    authors: [{ name: "HeliosLabs.AI Team" }],
    openGraph: {
      title: "HeliosLabs.AI - Unlock Efficiency with AI-Powered Workflow Automation",
      description: "Revolutionize your backend business operations with HeliosLabs.AI. We bring light to complex processes, transforming them into streamlined, intelligent operations.",
      images: [{ url: "https://helioslabs.ai/image/og-image.png" }], // Replace with your actual image URL
      type: "website",
    },
    twitter: {
      card: "summary_large_image",
      title: "HeliosLabs.AI - AI-Powered Business Automation",
      description: "Pioneering AI solutions for smarter, more efficient business operations in supply chain, logistics, and transportation.",
      images: ["https://helioslabs.ai/image/twitter-image.png"], // Replace with your actual image URL
    },
    robots: "index, follow",
    themeColor: "#141435", // Replace with your brand's primary color
    viewport: "width=device-width, initial-scale=1",
    icons: {
      icon: "/favicon2.ico", // Make sure you have this file in your public directory
      apple: "/apple-icon.png", // Make sure you have this file in your public directory
    },
  };
  

const Layout = ({ children }) => {
  return (
    <>
      <Helmet>
        <title>{metadata.title}</title>
        <meta name="description" content={metadata.description} />
        <meta name="keywords" content={metadata.keywords} />
        <meta name="author" content={metadata.authors} />
        <meta name="robots" content={metadata.robots} />
        <meta name="theme-color" content={metadata.themeColor} />
        <meta name="viewport" content={metadata.viewport} />
      
        <meta property="og:title" content={metadata.openGraph.title} />
        <meta property="og:description" content={metadata.openGraph.description} />
        <meta property="og:image" content={metadata.openGraph.images} />
        <meta property="og:url" content={metadata.openGraph.url} />
        <meta property="og:type" content={metadata.openGraph.type} />

        <meta name="twitter:card" content={metadata.twitter.card} />
        <meta name="twitter:title" content={metadata.twitter.title} />
        <meta name="twitter:description" content={metadata.twitter.description} />
        <meta name="twitter:image" content={metadata.twitter.images} />
      </Helmet>
      <main>{children}</main>
    </>
  );
};

export default Layout;
